import {deepCopyObject, showAxiosError} from "../../../helper/helper";
import {Decimal} from 'decimal.js';
import moment from "moment";
import {ExternalCustomerMainType} from "../../../helper/enums";
import {request} from "../../../helper/APIUtils";

export function defaultVoucher(rowData,stoppageTypes) {
    let issueDate = moment.utc(rowData["issueDate"],"DD-MM-YYYY HH:mm:ss");
    let vknTckn = rowData["vknTckn"];
    let fullName = rowData["fullName"];
    let documentNo = rowData["documentNo"];
    let givenName = "";
    let familyName = "";


    let result = fullName.trim().split(" ");
    if (result.length === 1) {
        givenName = result[0].trim();
    } else if (result.length === 2) {
        givenName = result[0].trim();
        familyName = result[1].trim();
    } else if (result.length === 3) {
        givenName = result[0].trim();
        familyName = result[1].trim() + " " + result[2].trim();
    } else {

    }

    let cityName = "";
    let citySubdivisionName = "";
    let streetName = "";
    let fullAddress = rowData["fullAddress"];

    let resultAddress = fullAddress.trim().split("/");
    if (resultAddress.length === 1) {
        cityName = resultAddress[0].trim();
    } else if (resultAddress.length === 2) {
        citySubdivisionName = resultAddress[0].trim();
        cityName = resultAddress[1].trim();
    } else if (resultAddress.length === 3) {
        streetName = resultAddress[0].trim();
        citySubdivisionName = resultAddress[1].trim();
        cityName = resultAddress[2].trim();
    } else {

    }

    let quantity = rowData["quantity"];
    let unitPrice = new Decimal(rowData["unitPrice"]).toNumber();
    let stoppageCode = rowData["gvStoppageCode"];
    let percentage = getPercentageFromCode(stoppageCode,stoppageTypes);
    let lineExtensionAmount = new Decimal(rowData["lineExtensionAmount"]).toNumber();
    let itemName = rowData["itemName"];
    let stockCode = rowData["stockCode"];
    let voucher = {
        recordId: null,
        allowanceTotalAmount: 0,
        documentCurrencyCode: "TRY",
        sendingType: "ELEKTRONIK",
        documentId: null,
        documentTypeCode: "MUSTAHSILMAKBUZ",
        issueDate: issueDate,
        payableAmount: 1,
        paymentExchangeRate: null,
        profileId: "EARSIVBELGE",
        taxExclusiveAmount: 1,
        lineExtensionAmount: 1,
        taxInclusiveAmount: 1,
        documentUuid: null,
        deletedAt: null,
        customer: null,
        xsltPath: null,
        externalCustomer:
            {
                recordId: null,
                vknTckn: vknTckn,
                title: null,
                formattedName: null,
                givenName: givenName,
                middleName: null,
                familyName: familyName,
                city: null,
                taxOffice: null,
                commerceChamber: null,
                buyerType: null,
                customer: null,
                mersisNumber: null,
                tradeRegistrationNumber: null,
                customerType: null,
                customerRiskLimit: null,
                initialBalance: null,
                externalCustomerAddressList: null,
                externalCustomerBankList: null
            },
        externalCustomerAddress:
            {
                recordId: null,
                postboxAlias: null,
                gbAlias: null,
                addressName: null,
                countryName: "Türkiye",
                cityName: cityName,
                citySubdivisionName: citySubdivisionName,
                buildingName: null,
                streetName: streetName,
                postalAddressRegion: null,
                buildingNo: null,
                postalAddressRoom: null,
                postalZone: null,
                telephone: null,
                fax: null,
                webSite: null,
                email: null,
                contactPerson: null
            },
        trdDocVoucherLines:
            [{
                recordId: null,
                itemId: null,
                itemCode: stockCode,
                itemName: itemName,
                quantity: quantity,
                unit: (rowData["unit"] === "ADET" ? "C62" : rowData["unit"]),
                unitPrice: unitPrice,
                lineExtensionAmount: lineExtensionAmount,
                note: null,

                trdDocVoucherLineCharges:
                    [{
                        recordId: null,
                        taxCode: {
                            recordId: 2,
                            code: "0003",
                            shortName: "GV STOPAJI",
                            longName: "GELİR VERGİSİ STOPAJI",
                            direction: -1,
                            calculatedBy: "AMOUNT",
                            priority: 2,
                            affectTaxableAmount: 1,
                            mm: 1,
                            smm: 1,
                            inv: 1,
                            isAffectKdv: 0
                        },
                        calculateFrom: "Stoppage",
                        percentage: percentage,
                        amount: "",
                        direction: -1,
                        exemptionReasonCode: null,
                        exemptionReason: null,
                        perUnitAmount: 0,
                        calculatedBy: "AMOUNT",
                        taxableAmount: 1,
                        withholdingCode: null,
                        stoppageCode: stoppageCode
                    }]
            }],
        trdDocVoucherNotes: [{recordId: null, note: ""}]
    };
    if (rowData && Object.keys(rowData).length >= 10) {

        if (rowData["borsaAmount"] >= 0) {
            voucher.trdDocVoucherLines[0].trdDocVoucherLineCharges.push(
                {
                    recordId: null,
                    percentage: null,
                    amount: rowData["borsaAmount"],
                    direction: -1,
                    exemptionReasonCode: null,
                    perUnitAmount: 0,
                    calculatedBy: "AMOUNT",
                    calculateFrom: "amount",
                    priority: 3,
                    taxCode: {
                        recordId: 7,
                        code: "8001_8001",
                        shortName: "BORSA TES.ÜC.",
                        longName: "BORSA TESCİL ÜCRETİ",
                        direction: -1,
                        calculatedBy: "AMOUNT",
                        priority: 3,
                        affectTaxableAmount: 1,
                        mm: 1,
                        smm: 0,
                        inv: 1,
                        isAffectKdv: 0
                    },
                    taxableAmount: lineExtensionAmount,
                    voucherItemLineId: null

                }
            );
        }
        if (rowData["meraAmount"] >= 0) {
            voucher.trdDocVoucherLines[0].trdDocVoucherLineCharges.push(
                {
                    recordId: null,
                    percentage: null,
                    amount: rowData["meraAmount"],
                    direction: -1,
                    exemptionReasonCode: null,
                    perUnitAmount: 0,
                    calculatedBy: "AMOUNT",
                    calculateFrom: "amount",
                    priority: 2,
                    taxCode: {
                        recordId: 8,
                        code: "9040",
                        shortName: "MERA FONU",
                        longName: "MERA FONU",
                        direction: -1,
                        calculatedBy: "AMOUNT",
                        priority: 2,
                        affectTaxableAmount: 1,
                        mm: 1,
                        smm: 0,
                        inv: 1,
                        isAffectKdv: 0
                    },
                    taxableAmount: lineExtensionAmount,
                    voucherItemLineId: null

                }
            );
        }
        if (rowData["sgkAmount"] >= 0) {
            voucher.trdDocVoucherLines[0].trdDocVoucherLineCharges.push(
                {
                    recordId: null,
                    percentage: null,
                    amount: rowData["sgkAmount"],
                    direction: -1,
                    exemptionReasonCode: null,
                    calculateFrom: "amount",
                    perUnitAmount: 0,
                    calculatedBy: "AMOUNT",
                    priority: 2,
                    taxCode: {
                        recordId: 17,
                        code: "SGK_PRIM",
                        shortName: "SGK PRİM KESİNTİSİ",
                        longName: "SGK PRİM KESİNTİSİ",
                        direction: -1,
                        calculatedBy: "AMOUNT",
                        priority: 2,
                        affectTaxableAmount: 1,
                        mm: 1,
                        smm: 0,
                        inv: 0,
                        isAffectKdv: 0
                    },
                    taxableAmount: lineExtensionAmount,
                    voucherItemLineId: null

                }
            );
        }
    }
    voucher = deepCopyObject(voucher);
    return [documentNo, voucher];
}

export function defaultSVoucher(rowData,stoppageTypes) {
    let issueDate = moment.utc(rowData["issueDate"],"DD-MM-YYYY HH:mm:ss");
    let vknTckn = rowData["vknTckn"];
    let givenName = rowData["givenName"];
    let familyName = rowData["familyName"];
    let formattedName = rowData["formattedName"];
    let documentNo = rowData["documentNo"];
    let tevkifatAmount = new Decimal(rowData["tevkifatAmount"]).toNumber();
    let gercekAmount = new Decimal(rowData["gercekAmount"]).toNumber();
    let stoppageCode = rowData["gvStoppageCode"];
    let percentage = (rowData["gvStoppageCode"] === "023") ? (rowData["percentage"] ? rowData["percentage"] : 0  ) : getPercentageFromCode(stoppageCode,stoppageTypes);
    let calculateGVFrom = (percentage===null)?"amount":"percentage";
    let lineExtensionAmount = new Decimal(rowData["lineExtensionAmount"]).toNumber();
    let cityName = rowData["cityName"];
    let citySubdivisionName = rowData["citySubdivisionName"];
    let itemName = rowData["itemName"];
    let note;

    if (rowData["note"]) {
        note = rowData["note"];
    } else {
        note = "";
    }
    let trdDocVoucherLineCharges = [{
        recordId: null,
        taxCode: {
            recordId: 1,
            code: "0015",
            shortName: "KDV GERCEK",
            longName: "GERÇEK USULDE KATMA DEĞER VERGİSİ",
            direction: 1,
            calculatedBy: "AMOUNT",
            priority: 4,
            affectTaxableAmount: 0,
            mm: 0,
            smm: 1,
            inv: 1,
            isAffectKdv: 0
        },
        calculateBy: "AMOUNT",
        calculateFrom: "amount",

        percentage: null,
        amount: gercekAmount,
        direction: 1,
        exemptionReasonCode: null,
        exemptionReason: null,
        perUnitAmount: 0,
        calculatedBy: "AMOUNT",
        taxableAmount: lineExtensionAmount,
        withholdingCode: null
    }, {
        recordId: null,
        taxCode: {
            recordId: 6,
            code: "9015",
            shortName: "KDV TEVKİFATI",
            longName: "KDV TEVKİFATI",
            direction: -1,
            calculatedBy: "AMOUNT",
            priority: 5,
            affectTaxableAmount: 0,
            mm: 0,
            smm: 1,
            inv: 1,
            isAffectKdv: 0
        },
        calculateBy: "AMOUNT",
        calculateFrom: "amount",
        percentage: null,
        amount: tevkifatAmount,
        direction: -1,
        exemptionReasonCode: null,
        exemptionReason: null,
        perUnitAmount: 0,
        calculatedBy: "AMOUNT",
        taxableAmount: lineExtensionAmount,
        withholdingCode: null
    }, {
        recordId: null,
        taxCode: {
            recordId: 2,
            code: "0003",
            shortName: "GV STOPAJI",
            longName: "GELİR VERGİSİ STOPAJI",
            direction: -1,
            calculatedBy: "AMOUNT",
            priority: 2,
            affectTaxableAmount: 1,
            mm: 1,
            smm: 1,
            inv: 1,
            isAffectKdv: 0
        },
        calculateBy: "AMOUNT",
        calculateFrom: "Stoppage",
        percentage: percentage,
        amount: null,
        direction: -1,
        exemptionReasonCode: null,
        exemptionReason: null,
        perUnitAmount: 0,
        calculatedBy: "AMOUNT",
        taxableAmount: lineExtensionAmount,
        withholdingCode: null,
        stoppageCode: stoppageCode,
    }];

    let voucher = {
        recordId: null,
        allowanceTotalAmount: 0,
        documentCurrencyCode: "TRY",
        sendingType: "ELEKTRONIK",
        documentId: null,
        documentTypeCode: "SERBESTMESLEKMAKBUZ",
        issueDate: issueDate,
        payableAmount: 1,
        paymentExchangeRate: null,
        profileId: "EARSIVBELGE",
        taxExclusiveAmount: 1,
        lineExtensionAmount: lineExtensionAmount,
        taxInclusiveAmount: lineExtensionAmount,
        documentUuid: null,
        retailCustomer: (
            vknTckn === 11111111111 ||
            vknTckn === "11111111111" ||
            vknTckn === 2222222222 ||
            vknTckn === "2222222222"
        ),
        deletedAt: null,
        customer: null,
        xsltPath: null,
        externalCustomer: {
            recordId: null,
            vknTckn: vknTckn,
            title: null,
            formattedName: formattedName,
            givenName: givenName,
            middleName: null,
            familyName: familyName,
            city: null,
            taxOffice: null,
            commerceChamber: null,
            buyerType: null,
            customer: null,
            mersisNumber: null,
            tradeRegistrationNumber: null,
            customerType: null,
            customerRiskLimit: null,
            initialBalance: null,
            externalCustomerAddressList: null,
            externalCustomerBankList: null
        },
        externalCustomerAddress: {
            recordId: null,
            postboxAlias: null,
            gbAlias: null,
            addressName: "MERKEZ",
            countryName: "Türkiye",
            cityName: cityName,
            citySubdivisionName: citySubdivisionName,
            buildingName: null,
            streetName: null,
            postalAddressRegion: null,
            buildingNo: null,
            postalAddressRoom: null,
            postalZone: null,
            telephone: null,
            fax: null,
            webSite: null,
            email: null,
            contactPerson: null
        },
        trdDocVoucherLines: [{
            recordId: null,
            itemId: null,
            itemCode: null,
            itemName: itemName,
            quantity: 1,
            unit: "C62",
            unitPrice: lineExtensionAmount,
            lineExtensionAmount: lineExtensionAmount,
            note: null,
            trdDocVoucherLineCharges: trdDocVoucherLineCharges

        }],
        trdDocVoucherNotes: [{recordId: null, note: note}]
    };

    return [documentNo, voucher];
}

export function defaultDespatch(rowData) {
    let familyName = rowData["familyName"];
    let givenName = rowData["givenName"];
    let vknTckn = rowData["vknTckn"];
    let postboxAlias = rowData["postboxAlias"];
    let cityName = rowData["cityName"];
    let citySubdivisionName = rowData["citySubdivisionName"];
    let sourceUrn = rowData["sourceUrn"];
    let formattedName = rowData["formattedName"];
    let itemName = rowData["itemName"];
    let deliveryCitySubdivision = rowData["deliveryCitySubdivision"];
    let deliveryPostalZone = rowData["deliveryPostalZone"];
    let deliveryType = rowData["deliveryType"];
    let driverFirstName = rowData["driverFirstName"];
    let driverFamilyName = rowData["driverFamilyName"];
    let deliveryCity = rowData["deliveryCity"];
    let carrierId = rowData["carrierId"];
    let carrierTitle = rowData["carrierTitle"];
    let quantity = new Decimal(rowData["quantity"]).toNumber();
    let unitPrice = rowData["unitPrice"] ? new Decimal(rowData["unitPrice"]).toNumber() : 0;
    let documentNo = rowData["documentNo"];
    let deliveryStreetName = rowData["deliveryStreetName"];
    let licensePlateID = rowData["licensePlateID"];
    let streetName = rowData["streetName"];
    let orderReferenceNumber = rowData["orderReferenceNumber"];
    let orderReferenceDate = moment.utc(rowData["orderReferenceDate"] + " " + rowData["orderReferenceDate"],"DD-MM-YYYYTHH:mm:ss");
    let note;
    let issueDate = moment.utc(rowData["issueDate"] + " " + rowData["issueTime"],"DD-MM-YYYYTHH:mm:ss");

    if (rowData["note"]) {
        note = rowData["note"];
    } else {
        note = "";
    }
    let despatch = {
        recordId: null,
        accountingCost: null,
        baseCurrencyCode: "TRY",
        documentCurrencyCode: "TRY",
        pricingAlternativeCurrencyCode: "TRY",
        documentId: null,
        despatchTypeCode: "SEVK",
        cancelDate: null,
        issueDate: issueDate,
        payableAmount: null,
        paymentExchangeRate: null,
        profileId: "TEMELIRSALIYE",
        lineExtensionAmount: null,
        documentUuid: null,
        deletedAt: null,
        xsltPath: null,
        cancelReason: null,
        cancelStatus: null,
        vknTckn: vknTckn,
        movementType: null,
        orderReferenceDate: orderReferenceDate,
        orderReferenceNumber: orderReferenceNumber,
        sgkFileNo: null,
        sourceUrn: sourceUrn,
        title: formattedName,

        externalCustomer: {
            buyerType: null,
            city: null,
            commerceChamber: null,
            customer: null,
            customerRiskLimit: null,
            customerType: null,
            externalCustomerAddressList: [{
                addressName: "MERKEZ",
                buildingName: null,
                buildingNo: null,
                cityName: cityName,
                citySubdivisionName: citySubdivisionName,
                countryName: "TÜRKİYE",
                email: null,
                fax: null,
                gbAlias: null,
                manualInput: null,
                postalAddressRoom: null,
                postalAddressRegion: null,
                postalZone: null,
                postboxAlias: postboxAlias,
                recordId: null,
                streetName: streetName,
                telephone: null,
                webSite: null
            }],
            externalCustomerBankList: null,
            familyName: familyName,
            formattedName: formattedName,
            givenName: givenName,
            initialBalance: null,
            mersisNumber: null,
            middleName: null,
            recordId: null,
            taxOffice: null,
            title: null,
            tradeRegistrationNumber: null,
            vknTckn: vknTckn,
        },
        externalCustomerAddress: {
            recordId: null,
            postboxAlias: postboxAlias,
            gbAlias: null,
            addressName: "MERKEZ",
            countryName: "Türkiye",
            cityName: cityName,
            citySubdivisionName: citySubdivisionName,
            buildingName: null,
            streetName: streetName,
            postalAddressRegion: null,
            buildingNo: null,
            postalAddressRoom: null,
            postalZone: null,
            telephone: null,
            fax: null,
            webSite: null,
            email: null,
            contactPerson: null,
            manualInput: null
        },
        despatchAdditiınalDocuments: {},
        despatchLines: [{
            barcode: null,
            itemCode: null,
            itemId: null,
            itemName: itemName,
            lineExtensionAmount: null,
            note: null,
            outstandingQuantity: null,
            outstandingReason: null,
            quantity: quantity,
            recordId: null,
            unit: (rowData["unit"] === "ADET" ? "C62" : rowData["unit"]),
            unitPrice: unitPrice,
        }],
        despatchNotes: [{
            note: note,
            recordId: null,
        }],
        despatchParties: [],
        despatchShipment: {
            actualDespatchDatetime:  moment(rowData["actualDespatchDatetime"] + " " + rowData["actualDespatchDatehour"], "DD-MM-YYYY HH:mm:ss"),
            carrierId: carrierId,
            carrierTitle: carrierTitle,
            deliveryBuildingName: null,
            deliveryBuildingNumber: null,
            deliveryCity: deliveryCity,
            deliveryCitySubdivision: deliveryCitySubdivision,
            deliveryCountry: "Türkiye",
            deliveryPostalZone: deliveryPostalZone,
            deliveryRegion: null,
            deliveryRoomNumber: null,
            deliveryStreet: deliveryStreetName,
            deliveryType: deliveryType.toUpperCase() === "FIRMA" ? "CARRIER" : (deliveryType.toUpperCase() === "ŞAHIS" ? "DRIVER" : null),
            driverInfos: deliveryType.toUpperCase() === "ŞAHIS" ? [{firstName: driverFirstName, familyName:driverFamilyName, identityCardNo: carrierId}] : [] ,
            recordId: null,
            transportId: licensePlateID,
            valueAmount: null
        }

    };
    return [documentNo, despatch];
}


export function defaultSigorta(rowData) {
    let documentNo = rowData["documentNo"];
    let documentCurrencyCode = rowData["documentCurrencyCode"];
    let paymentExchangeRate = rowData["paymentExchangeRate"];
    let familyName = rowData["familyName"];
    let givenName = rowData["givenName"];
    let vknTckn = rowData["vknTckn"];
    let formattedName = rowData["formattedName"];
    let taxOffice = rowData["taxOffice"];
    let cityName = rowData["cityName"];
    let citySubdivisionName = rowData["citySubdivisionName"];
    let countryName = rowData["countryName"];
    let itemName = rowData["itemName"];
    let streetName = rowData["streetName"];
    let productCommissionPrice = rowData["productCommissionPrice"];
    let cancelCommissionPrice = rowData["cancelCommissionPrice"];
    let postboxAlias = rowData["postboxAlias"];
    let periodStartDateTime = moment(rowData["periodStartDateTime"], "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DDTHH:mm:ss");
    let periodEndDateTime = moment(rowData["periodEndDateTime"], "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DDTHH:mm:ss");
    let note;
    let issueDate = moment.utc(rowData["issueDate"] + " " + rowData["issueTime"],"DD-MM-YYYYTHH:mm:ss");

    if (rowData["note"]) {
        note = rowData["note"];
    } else {
        note = "";
    }
    let sigorta = {
        recordId: null,
        documentCurrencyCode: documentCurrencyCode,
        documentId: null,
        issueDate: issueDate,
        allowanceTotalAmount: productCommissionPrice,
        chargeTotalAmount: cancelCommissionPrice,
        paymentExchangeRate: paymentExchangeRate,
        profileId: "EARSIVBELGE",
        lineExtensionAmount: null,
        documentUuid: null,
        deletedAt: null,
        xsltPath: null,
        vknTckn: vknTckn,
        title: formattedName,
        periodStartDateTime: periodStartDateTime,
        periodEndDateTime: periodEndDateTime,
        externalCustomer: {
            buyerType: null,
            city: null,
            commerceChamber: null,
            customer: null,
            customerRiskLimit: null,
            customerType: null,
            externalCustomerAddressList: [{
                addressName: "MERKEZ",
                buildingName: null,
                buildingNo: null,
                cityName: cityName,
                citySubdivisionName: citySubdivisionName,
                countryName: countryName,
                email: null,
                fax: null,
                gbAlias: null,
                manualInput: null,
                postalAddressRoom: null,
                postalAddressRegion: null,
                postalZone: null,
                postboxAlias: postboxAlias,
                recordId: null,
                streetName: streetName,
                telephone: null,
                webSite: null
            }],
            externalCustomerBankList: null,
            familyName: familyName,
            formattedName: formattedName,
            givenName: givenName,
            initialBalance: null,
            mersisNumber: null,
            middleName: null,
            recordId: null,
            taxOffice: null,
            title: null,
            tradeRegistrationNumber: null,
            vknTckn: vknTckn,
        },
        externalCustomerAddress: {
            recordId: null,
            postboxAlias: postboxAlias,
            gbAlias: null,
            addressName: "MERKEZ",
            countryName: countryName,
            cityName: cityName,
            citySubdivisionName: citySubdivisionName,
            buildingName: null,
            streetName: streetName,
            postalAddressRegion: null,
            buildingNo: null,
            postalAddressRoom: null,
            postalZone: null,
            telephone: null,
            fax: null,
            webSite: null,
            email: null,
            contactPerson: null,
            manualInput: null
        },
        trdDocSigortaLines: [{
            itemName: itemName,
            productCommissionPrice: productCommissionPrice,
            cancelCommissionPrice : cancelCommissionPrice,
            recordId: null,
        }],
        trdDocSigortaNotes: [{
            note: note,
            recordId: null,
        }],

    };
    return [documentNo, sigorta];
}

export function defaultStock(rowData) {
    let stockCode = rowData["stockCode"];
    let stockName = rowData["stockName"];
    let kdvBuy = new Decimal(rowData["kdvBuy"]).toNumber();
    let kdvSell = new Decimal(rowData["kdvSell"]).toNumber();
    let priceBuy = new Decimal(rowData["priceBuy"]).toNumber();
    let priceSell = new Decimal(rowData["priceSell"]).toNumber();
    let currency = rowData["currency"];
    let unit = rowData["unit"];
    let alias = rowData["alias"];
    let explanation = rowData["explanation"];
    let kdvSellExemption = rowData["kdvSellExemption"];
    let kdvPurchaseExemption = rowData["kdvPurchaseExemption"];
    let gtip = rowData["gtip"];

    let stock = {
        recordId: null,
        customerId: null,
        alias: alias,
        code: stockCode,
        name: stockName,
        explanation: explanation,
        itemType: {recordId:1,itemName:"MAL"},
        stockGroup: 1,
        kdvPurchase: kdvBuy,
        kdvSell: kdvSell,
        gvStoppagePurchase: 0,
        gvStoppageSell: 0,
        kdvSellExemption: kdvSellExemption,
        kdvPurchaseExemption: kdvPurchaseExemption,
        otv: 0,
        defaultCurrencyCode: currency,
        defPricePurchase: priceBuy,
        defPriceSell: priceSell,
        baseUnit: unit,
        gtip: gtip,
    };
    return [stock];
}

export function defaultExternalCustomer(rowData) {
    let vkn_tckn = rowData["vkn_tckn"];
    let formatted_name = rowData["formatted_name"];
    let given_name = rowData["given_name"];
    let middle_name = rowData["middle_name"];
    let family_name = rowData["family_name"];
    let commerce_chamber = rowData["commerce_chamber"];
    let city = rowData["city"];
    let tax_office = rowData["tax_office"];
    let mersis_number = rowData["mersis_number"];
    let trade_registration_number = rowData["trade_registration_number"];
    let customer_type;
    if (rowData["customer_type"].toString().toLocaleLowerCase() === "satıcı")
        customer_type = 1;
    else if (rowData["customer_type"].toString().toLocaleLowerCase() === "alıcı")
        customer_type = 2;
    else if (rowData["customer_type"].toString().toLocaleLowerCase() === "her ikisi")
        customer_type = 3;
    else
        customer_type = 3;
    let initial_balance = rowData["initial_balance"].toString() === "" ? null : new Decimal(rowData["initial_balance"]).toNumber();
    let customer_risk_limit = rowData["customer_risk_limit"].toString() === "" ? null : new Decimal(rowData["customer_risk_limit"]).toNumber();
    let address_name = rowData["address_name"];
    let contact_person = rowData["contact_person"];
    let postbox_alias = rowData["postbox_alias"];
    let despatch_postbox_alias = rowData["despatch_postbox_alias"];
    let country_name = rowData["country_name"];
    let city_name = rowData["city_name"];
    let city_subdivision_name = rowData["city_subdivision_name"];
    let web_site = rowData["web_site"];
    let email = rowData["email"];
    let telephone = rowData["telephone"];
    let fax = rowData["fax"];
    let postal_address_region = rowData["postal_address_region"];
    let building_name = rowData["building_name"];
    let building_no = rowData["building_no"];
    let postal_address_room = rowData["postal_address_room"];
    let postal_zone = rowData["postal_zone"];
    let bank_name = rowData["bank_name"];
    let iban = rowData["iban"];
    let isForeignCustomer = rowData["is_foreign_customer"].toUpperCase() === "EVET";

    let externalCustomer = {
        recordId: null,
        vknTckn: vkn_tckn,
        title: formatted_name,
        formattedName: formatted_name,
        givenName: given_name,
        middleName: middle_name,
        familyName: family_name,
        city: city,
        taxOffice: tax_office,
        commerceChamber: commerce_chamber,
        buyerType: isForeignCustomer ? 'OZEL' : null,
        customer: null,
        mersisNumber: mersis_number,
        tradeRegistrationNumber: trade_registration_number,
        customerType: customer_type,
        customerRiskLimit: customer_risk_limit,
        initialBalance: initial_balance,
        externalCustomerMainType : isForeignCustomer ? ExternalCustomerMainType.Foreign : ExternalCustomerMainType.Normal,
        externalCustomerAddressList: [{
            recordId: null,
            postboxAlias: postbox_alias,
            gbAlias: null,
            despatchPostboxAlias: despatch_postbox_alias,
            despatchGbAlias: null,
            addressName: address_name,
            countryName: country_name,
            cityName: city_name,
            citySubdivisionName: city_subdivision_name,
            buildingName: building_name,
            streetName: postal_address_region,
            postalAddressRegion: postal_address_region,
            buildingNo: building_no,
            postalAddressRoom: postal_address_room,
            postalZone: postal_zone,
            telephone: telephone,
            fax: fax,
            webSite: web_site,
            email: email,
            contactPerson: contact_person,
            manualInput: null,
            externalCustomer: null
        }],
        externalCustomerBankList: [{
            recordId: null,
            bankName: bank_name,
            iban: iban,
            externalCustomer: null
        }]
    };
    return [externalCustomer];
}

export function defaultRequestBank(excelData, exemptions, withholdingCodes){
    let rowData = excelData[0];
    return{
        // urun_hizmet: null,
        olay_numarasi: null,
        // urun_id: null,
    };
}

export function defaultInvoice(excelData,exemptions,withholdingCodes) {
    let rowData = excelData[0];
    return {
        accountingCost: null,
        actualDeliveryDate: rowData["deliveryDate"] === "1900-01-0" ? null : (rowData["deliveryDate"] ? (moment(rowData["deliveryDate"]).isValid("DD-MM-YYYY") ? moment.utc(rowData["deliveryDate"]) : moment.utc(rowData["deliveryDate"],"DD-MM-YYYY")): null),
        allowanceTotalAmount: 0,
        baseCurrencyCode: null,
        cancelDate: null,
        cancelReason: null,
        cancelStatus: null,
        carrierPartyFirstName: rowData["carrierFirstName"] ? rowData["carrierFirstName"] : null,
        carrierPartyFamilyName: rowData["carrierFamilyName"] ? rowData["carrierFamilyName"] : null,
        carrierPartyName: rowData["carrierTitle"] ? rowData["carrierTitle"] : null,
        carrierPartyId: rowData["carrierVknTckn"] ? rowData["carrierVknTckn"] : null,
        customer: null,
        customerBranch: null,
        deletedAt: null,
        documentCurrencyCode: rowData["documentCurrencyCode"],
        documentId: null,
        documentUuid: null,
        externalCustomer:
            {
                recordId: null,
                vknTckn: rowData["vknTckn"],
                title: (rowData["formattedName"] || (rowData["givenName"] + " " + rowData["familyName"])),
                formattedName: rowData["formattedName"],
                givenName: rowData["givenName"],
                middleName: null,
                familyName: rowData["familyName"],
                city: null,
                taxOffice: rowData["taxOffice"],
                commerceChamber: null,
                buyerType: null,
                customer: null,
                mersisNumber: null,
                tradeRegistrationNumber: null,
                customerType: null,
                customerRiskLimit: null,
                initialBalance: null,
                externalCustomerAddressList: [],
                externalCustomerBankList: null
            },
        externalCustomerAddress:
            {
                recordId: null,
                postboxAlias: rowData["destinationUrn"],
                gbAlias: null,
                addressName: null,
                countryName: rowData["countryName"],
                cityName: rowData["cityName"],
                citySubdivisionName: rowData["citySubdivisionName"],
                buildingName: null,
                streetName: rowData["streetName"],
                postalAddressRegion: null,
                buildingNo: null,
                postalAddressRoom: null,
                postalZone: null,
                telephone: rowData["telephone"] ? rowData["telephone"] : null,
                fax: null,
                webSite: null,
                email: rowData["email"],
                contactPerson: null
            },
        invoiceTypeCode: rowData["invoiceTypeCode"],
        issueDate:  moment.utc(rowData["issueDate"] + " " + rowData["issueTime"],"DD-MM-YYYY HH:mm:ss"),
        lineExtensionAmount: 1,
        orderReferenceDate: null,
        orderReferenceNumber: null,
        payableAmount: 1.20,
        paymentAlternativeCurrencyCode: rowData["documentCurrencyCode"],
        paymentChannelCode: null,
        paymentExchangeRate: rowData["paymentExchangeRate"],
        paymentFinancialAccountId: null,
        paymentMeansCode: null,
        paymentType: null,
        paymentValue: null,
        periodEndDate: null,
        periodStartDate: null,
        pricingCurrenyCode: null,
        profileId: rowData["profileId"],
        recordId: null,
        retailCustomer: (
            rowData["vknTckn"] === 11111111111 ||
            rowData["vknTckn"] === "11111111111" ||
            rowData["vknTckn"] === 2222222222 ||
            rowData["vknTckn"] === "2222222222"
        ),
        sendingType: "ELEKTRONIK",
        sgkFileNo: null,
        sourceUrn: rowData["sourceUrn"],
        taxCurrencyCode: rowData["documentCurrencyCode"],
        taxExclusiveAmount: 1,
        taxInclusiveAmount: 1.20,
        trdDocExternalCustomer: (
            rowData["vknTckn"] === 11111111111 ||
            rowData["vknTckn"] === "11111111111" ||
            rowData["vknTckn"] === 2222222222 ||
            rowData["vknTckn"] === "2222222222"
        ) ? {
            cityName: rowData["cityName"],
            citySubdivisionName: rowData["citySubdivisionName"],
            countryName: rowData["countryName"],
            email: rowData["email"],
            familyName: rowData["familyName"],
            formattedName: rowData["formattedName"],
            givenName: rowData["givenName"],
            streetName: rowData["streetName"],
            vknTckn: rowData["vknTckn"]
        } : null,
        trdDocInvoiceAdditionalDocuments: null,
        trdDocInvoiceDespatchReferences: [{
            recordId:null,
            referenceId: rowData["referenceId"] ? rowData["referenceId"] : null,
            referenceIssueDate: rowData["referenceIssueDate"] === "1900-01-0" ? null : (rowData["referenceIssueDate"] ? (moment(rowData["referenceIssueDate"]).isValid("DD-MM-YYYY") ? moment.utc(rowData["referenceIssueDate"]) : moment.utc(rowData["referenceIssueDate"],"DD-MM-YYYY")): null),
        }],
        trdDocInvoiceInternetSales:
            rowData["paymentMethod"] === null || rowData["paymentMethod"] === undefined || rowData["paymentMethod"] === ""  ?
                null
                :
                {
                    webSite: rowData["webSite"] ? rowData["webSite"] : null,
                    documentType: rowData["paymentMethod"] ? rowData["paymentMethod"] : null,
                    issueDate: rowData["paymentDate"] === "1900-01-0" ? null : (rowData["paymentDate"] ? (moment(rowData["paymentDate"]).isValid("DD-MM-YYYY") ? moment.utc(rowData["paymentDate"]) : moment.utc(rowData["paymentDate"], "DD-MM-YYYY")) : null),
                    documentId: "INTERNET_SATIS",
                    documentTypeCode: "ODEME_SEKLI",
                    description: rowData["paymentDetails"] ? rowData["paymentDetails"] : null,
                },
        trdDocInvoiceLines: invoiceLines(excelData,exemptions,withholdingCodes),
        trdDocInvoiceIadeLines: [{
            recordId: null,
            invoiceNumber: rowData["invoiceNumber"] === null ? null : rowData["invoiceNumber"],
            issueDate: rowData["iadeIssueDate"] === null ? null : moment.utc(rowData["iadeIssueDate"] + " " + rowData["iadeIssueTime"],"DD-MM-YYYY HH:mm:ss")
        }],
        trdDocInvoiceNotes: [
            {
                note:rowData["note"] ? rowData["note"] : "",
                recordId: null
            }
        ],
        trdDocInvoiceTaxFree: null,
        vknTckn: rowData["vknTckn"],
        xsltPath: null,
    };
}

export function defaultBelge(excelData,exemptions,withholdingCodes) {
    let rowData = excelData[0];
    return {
        accountingCost: null,
        actualDeliveryDate: null,
        allowanceTotalAmount: 0,
        baseCurrencyCode: null,
        cancelDate: null,
        cancelReason: null,
        cancelStatus: null,
        carrierPartyFamilyName: null,
        carrierPartyFirstName: null,
        carrierPartyId: null,
        carrierPartyName: null,
        customer: null,
        customerBranch: null,
        deletedAt: null,
        documentCurrencyCode: rowData["documentCurrencyCode"],
        documentId: null,
        documentUuid: null,
        externalCustomer:
            {
                recordId: null,
                vknTckn: rowData["vknTckn"],
                title: (rowData["formattedName"] || (rowData["givenName"] + " " + rowData["familyName"])),
                formattedName: rowData["formattedName"],
                givenName: rowData["givenName"],
                middleName: null,
                familyName: rowData["familyName"],
                city: null,
                taxOffice: rowData["taxOffice"],
                commerceChamber: null,
                buyerType: null,
                customer: null,
                mersisNumber: null,
                tradeRegistrationNumber: null,
                customerType: null,
                customerRiskLimit: null,
                initialBalance: null,
                externalCustomerAddressList: [],
                externalCustomerBankList: null
            },
        externalCustomerAddress:
            {
                recordId: null,
                postboxAlias: null,
                gbAlias: null,
                addressName: null,
                countryName: rowData["countryName"],
                cityName: rowData["cityName"],
                citySubdivisionName: rowData["citySubdivisionName"],
                buildingName: null,
                streetName: rowData["streetName"],
                postalAddressRegion: null,
                buildingNo: null,
                postalAddressRoom: null,
                postalZone: null,
                telephone: null,
                fax: null,
                webSite: null,
                email: rowData["email"],
                contactPerson: null
            },
        documentTypeCode: rowData["documentTypeCode"],
        issueDate:  moment.utc(rowData["issueDate"] + " " + rowData["issueTime"],"DD-MM-YYYY HH:mm:ss"),
        lineExtensionAmount: 1,
        orderReferenceDate: null,
        orderReferenceNumber: null,
        payableAmount: 1.20,
        paymentAlternativeCurrencyCode: rowData["documentCurrencyCode"],
        paymentChannelCode: null,
        paymentExchangeRate: rowData["paymentExchangeRate"],
        paymentFinancialAccountId: null,
        paymentMeansCode: null,
        paymentType: null,
        paymentValue: null,
        periodEndDate: null,
        periodStartDate: null,
        pricingCurrenyCode: null,
        profileId: "EBELGE",
        recordId: null,
        retailCustomer: (
            rowData["vknTckn"] === 11111111111 ||
            rowData["vknTckn"] === "11111111111" ||
            rowData["vknTckn"] === 2222222222 ||
            rowData["vknTckn"] === "2222222222"
        ),
        sendingType: "ELEKTRONIK",
        sgkFileNo: null,
        sourceUrn: null,
        taxCurrencyCode: rowData["documentCurrencyCode"],
        taxExclusiveAmount: 1,
        taxInclusiveAmount: 1.20,
        trdDocExternalCustomer: (
            rowData["vknTckn"] === 11111111111 ||
            rowData["vknTckn"] === "11111111111" ||
            rowData["vknTckn"] === 2222222222 ||
            rowData["vknTckn"] === "2222222222"
        ) ? {
            cityName: rowData["cityName"],
            citySubdivisionName: rowData["citySubdivisionName"],
            countryName: rowData["countryName"],
            email: rowData["email"],
            familyName: rowData["familyName"],
            formattedName: rowData["formattedName"],
            givenName: rowData["givenName"],
            streetName: rowData["streetName"],
            vknTckn: rowData["vknTckn"]
        } : null,
        trdDocBelgeDespatchReferences: [{
            recordId:null,
            referenceId: rowData["referenceId"] ? rowData["referenceId"] : null,
            referenceIssueDate: rowData["referenceIssueDate"] === "1900-01-0" ? null : (rowData["referenceIssueDate"] ? (moment(rowData["referenceIssueDate"]).isValid("DD-MM-YYYY") ? moment.utc(rowData["referenceIssueDate"]) : moment.utc(rowData["referenceIssueDate"],"DD-MM-YYYY")): null),
        }],
        trdDocBelgeLines: belgeLines(excelData,exemptions,withholdingCodes),
        trdDocBelgeNotes: [
            {
                note:rowData["note"] ? rowData["note"] : "",
                recordId: null
            }
        ],
        trdDocBelgeTaxFree: null,
        vknTckn: rowData["vknTckn"],
        xsltPath: null,
    };
}


export function invoiceLines(lines,exemptions,withholdingCodes) {
    let invoiceLines = [];
    for (let i = 0; i < lines.length; i++) {
        let line = lines[i];
        let lineTmp = {
            barcode: null,
            gumrukTakipNo: "",
            itemCode: null,
            itemId: null,
            itemName: line["itemName"],
            lineExtensionAmount: 1,
            note: null,
            orderLineReference: null,
            otvExemptionCode: null,
            quantity: line["quantity"],
            recordId: null,
            trdDocInvoiceLineCharges: [{
                amount: 0,
                calculatedBy: "AMOUNT",
                calculateFrom: "percentage",
                direction: -1,
                exemptionReason: null,
                exemptionReasonCode: null,
                perUnitAmount: 0,
                percentage: line["iskontoPercentage"],
                recordId: null,
                taxCode: {
                    affectTaxableAmount: 1,
                    calculatedBy: "AMOUNT",
                    code: "0000",
                    direction: -1,
                    inv: 1,
                    isAffectKdv: 1,
                    longName: "İSKONTO",
                    mm: 0,
                    priority: 1,
                    recordId: 5,
                    shortName: "İSKONTO",
                    smm: 0
                },
                taxableAmount: 1,
                withholdingCode: null,
            },
                {
                    amount: line["exemptionReasonCode"] ? 0.00 : 0.20,
                    calculatedBy: "AMOUNT",
                    calculateFrom: "percentage",
                    direction: 1,
                    exemptionReason: line["exemptionReasonCode"] ? exemptions.find(function (exemption) {return exemption.numberCode === (line["exemptionReasonCode"]).longCode}) : null,
                    exemptionReasonCode: line["exemptionReasonCode"],
                    perUnitAmount: 0,
                    percentage: line["kdvPercentage"],
                    recordId: null,
                    taxCode: {
                        affectTaxableAmount: 0,
                        calculatedBy: "AMOUNT",
                        code: "0015",
                        direction: 1,
                        inv: 1,
                        isAffectKdv: 0,
                        longName: "GERÇEK USULDE KATMA DEĞER VERGİSİ",
                        mm: 0,
                        priority: 4,
                        recordId: 1,
                        shortName: "KDV GERCEK",
                        smm: 1
                    },
                    taxableAmount: 1,
                    withholdingCode: null,
                },

            ],
            trdDocInvoiceLineDeliveryDetail: (!!line["gtip"] && line["gtip"] ? {
                gtip: line["gtip"]
            } : null)
            ,
            unit: (line["unit"] === "ADET" ? "C62" : line["unit"]),
            unitPrice: line["unitPrice"]
        };
        if(!!line["tevkifatAmount"] && line["tevkifatAmount"]){
            lineTmp.trdDocInvoiceLineCharges.push( {
                recordId: null,
                taxCode: {
                    recordId: 6,
                    code: "9015",
                    shortName: "KDV TEVKİFATI",
                    longName: "KDV TEVKİFATI",
                    direction: -1,
                    calculatedBy: "AMOUNT",
                    priority: 5,
                    affectTaxableAmount: 0,
                    mm: 0,
                    smm: 1,
                    inv: 1,
                    isAffectKdv: 0
                },
                calculateBy: "AMOUNT",
                calculateFrom: line["tevkifatAmount"] ? "withholdingCode" : "amount",
                percentage: getWithholdingPercentage(line["tevkifatAmount"],withholdingCodes),
                amount: 0,
                direction: -1,
                exemptionReasonCode: null,
                exemptionReason: null,
                perUnitAmount: 0,
                calculatedBy: "AMOUNT",
                taxableAmount: 1,
                withholdingCode: line["tevkifatAmount"] ? new Decimal(line["tevkifatAmount"]).toNumber() : null,
            })
        }
        invoiceLines.push(lineTmp);
    }
    return invoiceLines;
}


export function belgeLines(lines,exemptions,withholdingCodes) {
    let belgeLines = [];
    for (let i = 0; i < lines.length; i++) {
        let line = lines[i];
        let lineTmp = {
            barcode: null,
            gumrukTakipNo: "",
            itemCode: null,
            itemId: null,
            itemName: line["itemName"],
            lineExtensionAmount: 1,
            note: null,
            orderLineReference: null,
            otvExemptionCode: null,
            quantity: line["quantity"],
            recordId: null,
            trdDocBelgeLineCharges: [{
                amount: 0,
                calculatedBy: "AMOUNT",
                calculateFrom: "percentage",
                direction: -1,
                exemptionReason: null,
                exemptionReasonCode: null,
                perUnitAmount: 0,
                percentage: line["iskontoPercentage"],
                recordId: null,
                taxCode: {
                    affectTaxableAmount: 1,
                    calculatedBy: "AMOUNT",
                    code: "0000",
                    direction: -1,
                    inv: 1,
                    isAffectKdv: 1,
                    longName: "İSKONTO",
                    mm: 0,
                    priority: 1,
                    recordId: 5,
                    shortName: "İSKONTO",
                    smm: 0
                },
                taxableAmount: 1,
                withholdingCode: null,
            },
                {
                    amount: line["exemptionReasonCode"] ? 0.00 : 0.20,
                    calculatedBy: "AMOUNT",
                    calculateFrom: "percentage",
                    direction: 1,
                    exemptionReason: line["exemptionReasonCode"] ? exemptions.find(function (exemption) {return exemption.numberCode === (line["exemptionReasonCode"]).longCode}) : null,
                    exemptionReasonCode: line["exemptionReasonCode"],
                    perUnitAmount: 0,
                    percentage: line["kdvPercentage"],
                    recordId: null,
                    taxCode: {
                        affectTaxableAmount: 0,
                        calculatedBy: "AMOUNT",
                        code: "0015",
                        direction: 1,
                        inv: 1,
                        isAffectKdv: 0,
                        longName: "GERÇEK USULDE KATMA DEĞER VERGİSİ",
                        mm: 0,
                        priority: 4,
                        recordId: 1,
                        shortName: "KDV GERCEK",
                        smm: 1
                    },
                    taxableAmount: 1,
                    withholdingCode: null,
                },

            ],
            trdDocBelgeLineDeliveryDetail: (!!line["gtip"] && line["gtip"] ? {
                gtip: line["gtip"]
            } : null)
            ,
            unit: (line["unit"] === "ADET" ? "C62" : line["unit"]),
            unitPrice: line["unitPrice"]
        };
        if(!!line["tevkifatAmount"] && line["tevkifatAmount"]){
            lineTmp.trdDocBelgeLineCharges.push( {
                recordId: null,
                taxCode: {
                    recordId: 6,
                    code: "9015",
                    shortName: "KDV TEVKİFATI",
                    longName: "KDV TEVKİFATI",
                    direction: -1,
                    calculatedBy: "AMOUNT",
                    priority: 5,
                    affectTaxableAmount: 0,
                    mm: 0,
                    smm: 1,
                    inv: 1,
                    isAffectKdv: 0
                },
                calculateBy: "AMOUNT",
                calculateFrom: line["tevkifatAmount"] ? "withholdingCode" : "amount",
                percentage: getWithholdingPercentage(line["tevkifatAmount"],withholdingCodes),
                amount: 0,
                direction: -1,
                exemptionReasonCode: null,
                exemptionReason: null,
                perUnitAmount: 0,
                calculatedBy: "AMOUNT",
                taxableAmount: 1,
                withholdingCode: line["tevkifatAmount"] ? new Decimal(line["tevkifatAmount"]).toNumber() : null,
            })
        }
        belgeLines.push(lineTmp);
    }
    return belgeLines;
}

export function getPercentageFromCode(stoppageCode,stoppageTypes) {
    let percentage=null;
    if(stoppageCode === "" ||stoppageTypes.length === 0) {
        return percentage;
    }
    for (const stoppageType of stoppageTypes){
        if (stoppageType.code===stoppageCode){
            percentage=stoppageType.percentage;
            break;
        }
    }
    return  percentage;
}

export function getWithholdingPercentage(withholdingCode, withholdingCodes) {
    let percentage=null;
    if(withholdingCodes !== undefined){
        if(withholdingCode === "" || withholdingCode.length === 0) {
            return percentage;
        }
        withholdingCodes.map(codes =>{
            if (codes.code===withholdingCode.toString()){
                percentage=codes.percentage;
            }
        })
        return  percentage;
    }
}

/*export function defaultSigorta(rowData,stoppageTypes) {
    let issueDate = moment.utc(rowData["issueDate"],"DD-MM-YYYY HH:mm:ss");
    let vknTckn = rowData["vknTckn"];
    let fullName = rowData["fullName"];
    let documentNo = rowData["documentNo"];
    let givenName = "";
    let familyName = "";


    let result = fullName.trim().split(" ");
    if (result.length === 1) {
        givenName = result[0].trim();
    } else if (result.length === 2) {
        givenName = result[0].trim();
        familyName = result[1].trim();
    } else if (result.length === 3) {
        givenName = result[0].trim();
        familyName = result[1].trim() + " " + result[2].trim();
    } else {

    }

    let cityName = "";
    let citySubdivisionName = "";
    let streetName = "";
    let fullAddress = rowData["fullAddress"];

    let resultAddress = fullAddress.trim().split("/");
    if (resultAddress.length === 1) {
        cityName = resultAddress[0].trim();
    } else if (resultAddress.length === 2) {
        citySubdivisionName = resultAddress[0].trim();
        cityName = resultAddress[1].trim();
    } else if (resultAddress.length === 3) {
        streetName = resultAddress[0].trim();
        citySubdivisionName = resultAddress[1].trim();
        cityName = resultAddress[2].trim();
    } else {

    }
    let itemName = rowData["itemName"];
    let sigorta = {
        recordId: null,
        allowanceTotalAmount: 0,
        documentCurrencyCode: "TRY",
        sendingType: "ELEKTRONIK",
        documentId: null,
        documentTypeCode: "POLICE",
        issueDate: issueDate,
        payableAmount: 1,
        paymentExchangeRate: null,
        profileId: "EARSIVBELGE",
        taxExclusiveAmount: 1,
        lineExtensionAmount: 1,
        taxInclusiveAmount: 1,
        documentUuid: null,
        deletedAt: null,
        customer: null,
        xsltPath: null,
        externalCustomer:
            {
                recordId: null,
                vknTckn: vknTckn,
                title: null,
                formattedName: null,
                givenName: givenName,
                middleName: null,
                familyName: familyName,
                city: null,
                taxOffice: null,
                commerceChamber: null,
                buyerType: null,
                customer: null,
                mersisNumber: null,
                tradeRegistrationNumber: null,
                customerType: null,
                customerRiskLimit: null,
                initialBalance: null,
                externalCustomerAddressList: null,
                externalCustomerBankList: null
            },
        externalCustomerAddress:
            {
                recordId: null,
                postboxAlias: null,
                gbAlias: null,
                addressName: null,
                countryName: "Türkiye",
                cityName: cityName,
                citySubdivisionName: citySubdivisionName,
                buildingName: null,
                streetName: streetName,
                postalAddressRegion: null,
                buildingNo: null,
                postalAddressRoom: null,
                postalZone: null,
                telephone: null,
                fax: null,
                webSite: null,
                email: null,
                contactPerson: null
            },
        trdDocSigortaLines:
            [{
                recordId: null,
                itemName: itemName,
            }],
        trdDocSigortaNotes: [{recordId: null, note: ""}]
    };

    sigorta = deepCopyObject(sigorta);
    return [documentNo, sigorta];
}*/

